import { render, staticRenderFns } from "./PointsExchangePage.vue?vue&type=template&id=40b729ba&scoped=true"
import script from "./PointsExchangePage.vue?vue&type=script&lang=js"
export * from "./PointsExchangePage.vue?vue&type=script&lang=js"
import style0 from "./PointsExchangePage.vue?vue&type=style&index=0&id=40b729ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b729ba",
  null
  
)

export default component.exports